export default{
    methods: {
        removeElement(element, array, addElementFunction) {
            let index = array.indexOf(element);
            if (index >= 0) {
              let removed = array.splice(index, 1);
              if(array.length === 0){
                addElementFunction(element);
              }
            };
          },
          moveUp(element, array) {
            let index = array.indexOf(element);
            if (index > 0) {
              array.splice(index - 1, 0, element);
              array.splice(index + 1, 1);
            }
          },
          moveDown(element, array) {
            let index = array.indexOf(element);
            if (index < array.length) {
              array.splice(index + 2, 0, element);
              array.splice(index, 1);
            }
          },
    }
}